module.exports = __webpack_public_path__ + "std/img/raffle-wheel-start.b27c80e.png";


//////////////////
// WEBPACK FOOTER
// ./src/pages/build800/assets/image/raffle-wheel-start.png
// module id = r/Vv
// module chunks = 0 6